// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1tVjp","title":"AfterBackImages_title__3jG4B","images":"AfterBackImages_images__1vynM"};